import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Owner, Country, Provincia, Comune, Company, company } from 'toolbandi-ui-lib';
import { Search, ListItem, CrudService, MessageService, SharedDataService, ListService } from 'elbuild-ui-lib-core';
import { ClassType } from 'class-transformer/ClassTransformer';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-owner-edit',
	templateUrl: './owner-edit.component.html',
	styleUrls: ['./owner-edit.component.scss']
})
export class OwnerEditComponent implements OnInit, OnDestroy {


	loading: boolean = false;
	owner: Owner;
	tab: string;

	editable: boolean = true;

	search: {
		nazione: Search,
		comune: Search,
		provincia: Search,
		birthcity: Search,
		company: Search
	};
	selected: {
		nazione: Country,
		comune: Comune,
		provincia: Provincia,
		birthcity: Comune,
		company: Company
	};

	contracttypes: ListItem[] = [];
	contractlevels: ListItem[] = [];
	ownertypes: ListItem[] = [];
	mgmttypes: ListItem[] = [];

	companies: Company[] = [];

	nazioneClass: ClassType<Country> = Country;

	@Input()
	companyid: number;

	get isItalia(): boolean {
		return this.selected.nazione && this.selected.nazione.isItalia;
	}

	get notCountry(): boolean {
		return !this.selected.nazione || !this.selected.nazione.id;
	}

	constructor(
		private ownerService: CrudService<Owner>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private countryService: CrudService<Country>,
		private provinceService: CrudService<Provincia>,
		private comuneService: CrudService<Comune>,
		private companyService: CrudService<Company>,
		private router: Router,
		private activeModal: NgbActiveModal,
		private listService: ListService
	) {


		this.selected = {
			nazione: new Country(),
			comune: undefined,
			provincia: undefined,
			birthcity: undefined,
			company: undefined
		};

		this.search = {
			nazione: new Search('country'),
			comune: new Search('comuni'),
			provincia: new Search('province'),
			birthcity: new Search('comuni'),
			company: new Search('company')
		};

		this.listService.getListItemsBySlug('contract.type').subscribe(data => this.contracttypes = data);
		this.listService.getListItemsBySlug('contract.level').subscribe(data => this.contractlevels = data);
		this.listService.getListItemsBySlug('owner.type').subscribe(data => this.ownertypes = data);
		this.listService.getListItemsBySlug('owner.mgmttype').subscribe(data => this.mgmttypes = data);

		this.companyService.getAll(Company, 'company').subscribe(data => this.companies = data);

	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			} else {
				this.owner = new Owner();
				if (this.companyid)
					this.owner.companyid = this.companyid;
			}

		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.ownerService.getEntity(Owner, 'owner', id).subscribe(owner => {
			this.owner = owner;
			this.loading = false;
			this.initItem();
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.owner'));
			this.owner = undefined;
			this.loading = false;
		});
	}


	findCountry(name: any): void {
		if (name) {
			const countrySearch = new Search('country');
			countrySearch.addLikeFilter('name', name);
			this.countryService
				.searchEntities(Country, 'country', countrySearch, countrySearch.page)
				.subscribe((c: Country[]) => {
					this.selected.nazione = c[0];
				});
		}
	}

	findProvince(descrizione: any): void {
		if (descrizione) {
			const provinceSearch = new Search('province');
			provinceSearch.addLikeFilter('descrizione', descrizione);
			this.provinceService
				.searchEntities(Provincia, 'province', provinceSearch, provinceSearch.page)
				.subscribe((p: Provincia[]) => {
					this.selected.provincia = p[0];
				});
		}
	}

	findComune(descrizione: any): void {
		if (descrizione) {
			const comuneSearch = new Search('comuni');
			comuneSearch.addLikeFilter('descrizione', descrizione);
			this.comuneService
				.searchEntities(Comune, 'comuni', comuneSearch, comuneSearch.page)
				.subscribe((c: Comune[]) => {
					this.selected.comune = c[0];
				});
		}
	}

	findBirthcity(descrizione: any): void {
		if (descrizione) {
			const comuneSearch = new Search('comuni');
			comuneSearch.addLikeFilter('descrizione', descrizione);
			this.comuneService
				.searchEntities(Comune, 'comuni', comuneSearch, comuneSearch.page)
				.subscribe((c: Comune[]) => {
					this.selected.birthcity = c[0];
				});
		}
	}

	findCompany(cid: number): string {
		if (cid && this.companies.length) {
			return this.companies.find(c => c.id === cid).name;
		}
	}

	updateSelects() {

		if (this.selected.provincia) {
			this.search.comune.addSimpleFilter('provincia', this.selected.provincia.descrizione);
		} else {
			this.selected.comune = undefined;
		}
		if (this.selected.nazione === undefined || this.selected.nazione.name !== 'Italia') {
			this.selected.comune = undefined;
			this.selected.provincia = undefined;
		}

	}

	setSelectFields() {

		if (this.selected.nazione && this.selected.nazione.id) {
			this.owner.country = this.selected.nazione.name;
			// this.company.iso = this.selected.nazione.sigla;
		}
		if (this.selected.comune && this.selected.comune.id) {
			this.owner.city = this.selected.comune.descrizione;
		}
		if (this.selected.provincia && this.selected.provincia.id) {
			this.owner.province = this.selected.provincia.descrizione;
		}

		if (this.selected.birthcity) {
			this.owner.birthcity = this.selected.birthcity.descrizione;
		}

	}

	initItem() {
		this.findCountry(this.owner.country);
		this.findProvince(this.owner.province);
		this.findComune(this.owner.city);
		this.findBirthcity(this.owner.birthcity);
		this.findCompany(this.owner.companyid);
	}

	dismiss() {
		this.activeModal.dismiss();
	}

	submit() {
		this.setSelectFields();

		if (!this.owner.id) {

			this.ownerService.createEntity(Owner, 'owner', this.owner).subscribe(response => {
				this.owner = response;
				const messages = this.translateService.instant(['labels.owner-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.owner-save-success'], messages['labels.success']);
				this.activeModal.close(this.owner);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.ownerService.saveEntity(Owner, 'owner', this.owner).subscribe(response => {
				this.owner = response;
				this.initItem();
				const messages = this.translateService.instant(['labels.owner-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.owner-save-success'], messages['labels.success']);
				this.activeModal.close(this.owner);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

	updateCountry() {
		this.owner.province = undefined;
		this.owner.city = undefined;
		this.selected.provincia = undefined;
		this.selected.comune = undefined;
	}

	updateProvince() {
		this.selected.comune = undefined;
		this.owner.province = undefined;
		this.owner.city = undefined;

		if (this.selected.provincia) {
			this.search.comune.addSimpleFilter('provincia', this.selected.provincia.descrizione);
		}
	}

}

